import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M32 3a29 29 0 1029 29A29 29 0 0032 3zm0 56a27 27 0 1127-27 27 27 0 01-27 27z" /><path d="M45.27 21.31L27.18 40.54l-8.45-9a1 1 0 00-1.42 0 1 1 0 000 1.41l9.18 9.76a1 1 0 00.73.31 1 1 0 00.73-.31l18.82-20a1 1 0 00-1.46-1.38z" /></svg>);